// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19Ymp","badges":"styles_badges__1ltHm"};